import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useParent } from '../context/ParentContext';
import { FiArrowLeft, FiTrendingUp, FiTrendingDown, FiMinus } from 'react-icons/fi';
import ParentEmptyState from '../components/states/ParentEmptyState';
import './ParentCourseDetail.css';

function ParentCourseDetail() {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const { currentCourses, currentAssignments, currentActivity, currentActivityFeed } = useParent();

  const course = currentCourses.find(c => c.id === courseId);
  if (!course) {
    return (
      <div className="parent-course-detail">
        <button className="parent-course-detail__back" onClick={() => navigate('/parent/courses')}>
          <FiArrowLeft size={16} /> Back to Courses
        </button>
        <ParentEmptyState variant="no-data" />
      </div>
    );
  }

  const courseAssignments = currentAssignments.filter(a => a.courseId === courseId);
  const completed = courseAssignments.filter(a => a.status === 'completed');
  const inProgress = courseAssignments.filter(a => a.status === 'in-progress');
  const upcoming = courseAssignments.filter(a => a.status === 'not-started');
  const overdue = courseAssignments.filter(a => a.status === 'overdue');
  const courseActivity = currentActivityFeed.filter(a => a.course === course.name);

  const trendIcon = course.trend === 'improving' ? <FiTrendingUp /> : course.trend === 'declining' ? <FiTrendingDown /> : <FiMinus />;
  const trendColor = course.trend === 'improving' ? '#22c55e' : course.trend === 'declining' ? '#ef4444' : '#64748b';

  return (
    <div className="parent-course-detail">
      <button className="parent-course-detail__back" onClick={() => navigate('/parent/courses')}>
        <FiArrowLeft size={16} /> Back to Courses
      </button>

      <div className="parent-course-detail__header">
        <h1 className="parent-course-detail__title">{course.name}</h1>
        <span className="parent-course-detail__instructor">{course.instructor}</span>
        <div className="parent-course-detail__trend" style={{ color: trendColor }}>
          {trendIcon} {course.trend}
        </div>
      </div>

      {/* Progress */}
      <div className="parent-course-detail__progress">
        <div className="parent-course-detail__progress-bar">
          <div className="parent-course-detail__progress-fill" style={{ width: `${course.completionRate}%` }} />
        </div>
        <span>{course.completionRate}% complete</span>
      </div>

      {/* Assignment Breakdown */}
      <section className="parent-course-detail__section">
        <h2>Assignment Progress</h2>
        <div className="parent-course-detail__stats">
          <div className="parent-course-detail__stat"><span className="parent-course-detail__stat-value">{completed.length}</span><span>Completed</span></div>
          <div className="parent-course-detail__stat"><span className="parent-course-detail__stat-value">{inProgress.length}</span><span>In Progress</span></div>
          <div className="parent-course-detail__stat"><span className="parent-course-detail__stat-value">{upcoming.length}</span><span>Upcoming</span></div>
          <div className="parent-course-detail__stat parent-course-detail__stat--alert"><span className="parent-course-detail__stat-value">{overdue.length}</span><span>Overdue</span></div>
        </div>
      </section>

      {/* Study Activity */}
      <section className="parent-course-detail__section">
        <h2>Study Activity</h2>
        <div className="parent-course-detail__metrics">
          <div className="parent-course-detail__metric">
            <span className="parent-course-detail__metric-value">{currentActivity.quizzesCompleted || 0}</span>
            <span className="parent-course-detail__metric-label">Quizzes</span>
          </div>
          <div className="parent-course-detail__metric">
            <span className="parent-course-detail__metric-value">{currentActivity.flashcardsReviewed || 0}</span>
            <span className="parent-course-detail__metric-label">Flashcards Reviewed</span>
          </div>
          <div className="parent-course-detail__metric">
            <span className="parent-course-detail__metric-value">{currentActivity.notesCreated || 0}</span>
            <span className="parent-course-detail__metric-label">Notes Created</span>
          </div>
          <div className="parent-course-detail__metric">
            <span className="parent-course-detail__metric-value">{currentActivity.studyConversations || 0}</span>
            <span className="parent-course-detail__metric-label">Study Conversations</span>
          </div>
        </div>
      </section>

      {/* Recent Activity */}
      <section className="parent-course-detail__section">
        <h2>Recent Activity</h2>
        {courseActivity.length > 0 ? (
          <div className="parent-course-detail__feed">
            {courseActivity.map(item => (
              <div key={item.id} className="parent-course-detail__feed-item">
                <div className={`parent-course-detail__feed-dot parent-course-detail__feed-dot--${item.type}`} />
                <span className="parent-course-detail__feed-text">{item.description}</span>
                <span className="parent-course-detail__feed-date">{item.date}</span>
              </div>
            ))}
          </div>
        ) : (
          <p className="parent-course-detail__no-activity">No recent activity for this course.</p>
        )}
      </section>
    </div>
  );
}

export default ParentCourseDetail;
